var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthLayout',[_c('div',{staticClass:"mt-5"},[_c('empty-result',{attrs:{"label":"Oops!","description":"Settings Page under construction. Sorry for the inconvenience"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }